import type { CSSProperties, ReactNode } from 'react';

interface PillProps {
  children: ReactNode;
  bg?: string;
  color?: string;
  dot?: string;
  className?: string;
}

export function Pill({ children, bg, color, dot, className = '' }: PillProps) {
  const style: CSSProperties = {};
  if (bg) style.background = bg;
  if (color) style.color = color;

  return (
    <span
      style={style}
      className={[
        'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium',
        !bg && 'bg-bg-2',
        !color && 'text-fg',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {dot && (
        <span
          style={{ background: dot }}
          className="w-1.5 h-1.5 rounded-full inline-block"
        />
      )}
      {children}
    </span>
  );
}
